export default __webpack_public_path__ + "static/icon-3-2-b2b88166b60a20dbf5956323189135ce.png";